// import { IS_SP } from '../const/config';

export class Tab {
  constructor() {
    this.DOM = {};
    this.DOM.tabs = document.querySelectorAll('[data-tab]');

    if (!this.DOM.tabs) return;

    this.init();
  }

  init() {

    // タブグループごとの処理（複数のタブ設置に対応）
    this.DOM.tabs.forEach( (tab) => {

      const tabToggles = tab.querySelectorAll('[data-tab-name]');
      const tabContainer = tab.querySelector('[data-tab-container]');
      const tabContents = tab.querySelectorAll('[data-tab-contents]');
      
      // 最初の高さをセット
      if( tabContainer ){
        this._updateHeight(tabContainer);
      }

      // タブを押したときの処理
      tabToggles.forEach((tabButton) => {

        tabButton.addEventListener('click', () => {
          const targetTabName = tabButton.getAttribute('data-tab-name');

          // 1. ボタンのクラス切り替え
          tabToggles.forEach((t) => t.classList.remove('is-current'));
          tabButton.classList.add('is-current');
          tab.setAttribute('data-tab', targetTabName);

          // 2. コンテンツの切り替え
          if(tabContents.length !== 0 ){
            tabContents.forEach((content) => {
              content.classList.remove('is-current');
              if (content.getAttribute('data-tab-contents') === targetTabName) {
                content.classList.add('is-current');
              }
            });

            // 3. 高さを更新（トルツメの肝）
            this._updateHeight(tabContainer);
          }

  
        });
      });

      // ウィンドウリサイズ時にも高さを再計算
      if( tabContainer ){
        window.addEventListener('resize', this._updateHeight(tabContainer));
      }

    });
  }
  _updateHeight = (tabContainer) => {
    const currentContent = tabContainer.querySelector('[data-tab-contents].is-current');
    if (currentContent) {
      tabContainer.style.height = `${currentContent.offsetHeight}px`;
    }
  };
}
